
import EleChart from './src/main';

EleChart.install = function (Vue) {
  Vue.component(EleChart.name, EleChart);
};

export default EleChart;
